<template>
  <div id="Main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'Main'
}
</script>



// WEBPACK FOOTER //
// src/views/portal/functions/Main.vue